import { i18n } from "@/i18n";
import LayoutView from "@/views/Training/LayoutView.vue";
import PreRegistrationSheetView from "@/views/Registration/PreRegistrationSheetView.vue";
import RegistrationDashboardView from "@/views/Registration/RegistrationDashboardView.vue";
import RegistrationLayoutView from "@/views/Registration/RegistrationLayoutView.vue";
import RegistrationsListView from "@/views/Registration/RegistrationsListView.vue";
import TrainingListView from "@/views/Training/TrainingListView.vue";
import ApprenticeListView from "@/views/Registration/Apprentice/ApprenticeListView.vue";
import GlobalLayoutView from "@/views/Global/GlobalLayoutView.vue";
import InseeCompanyListView from "@/views/Registration/InseeCompany/InseeCompanyListView.vue";
import InseeCompanyViewView from "@/views/Registration/InseeCompany/InseeCompanyViewView.vue";
import ApprenticeAddEditView from "@/views/Registration/Apprentice/ApprenticeAddEditView.vue";
import TrainingGroupListView from "@/views/Training/TrainingGroupListView.vue";
import TrainingGroupAddEditView from "@/views/Training/TrainingGroupAddEditView.vue";
import RegistrationAlertListView from "@/views/Registration/Alert/RegistrationAlertListView.vue";
import PreRegistrationSheetCreateView from "@/views/Registration/PreRegistrationSheetCreateView.vue";

export default {
  path: "/registration",
  name: "Registration",
  component: LayoutView,
  redirect: { name: "TrainingList" },
  meta: {
    breadcrumb: true,
    authRequired: true,
    title: i18n.global.t("page.training_list"),
  },
  children: [
    {
      path: ":group/show/:tab/:registration?",
      name: "TrainingPreRegistration",
      component: PreRegistrationSheetView,
      meta: {
        authRequired: true,
        title: i18n.global.t("page.pre_registration"),
        breadcrumb: true,
        displayTrainingName: true,
      },
    },
    {
      path: ":group/create",
      name: "TrainingCreatePreRegistration",
      component: PreRegistrationSheetCreateView,
      meta: {
        title: i18n.global.t("registration.group_action.create"),
        authRequired: false,
        breadcrumb: true,
        displayTrainingName: true,
      },
    },
    {
      path: "dashboard",
      name: "RegistrationLayoutView",
      redirect: { name: "RegistrationDashboard" },
      component: RegistrationLayoutView,
      meta: {
        title: i18n.global.t("page.registration_dashboard"),
        breadcrumb: true,
        authRequired: true,
      },
      children: [
        {
          path: "",
          name: "RegistrationDashboard",
          component: RegistrationDashboardView,
          meta: {
            title: i18n.global.t("page.registration_dashboard"),
            breadcrumb: false,
          },
        },
        {
          path: "list",
          name: "RegistrationList",
          component: RegistrationsListView,
          meta: {
            title: i18n.global.tc("global.list.title", 1, {
              name: i18n.global.tc("studea_manager.registration.title", 2).toLowerCase(),
            }),
            breadcrumb: true,
          },
        },
        {
          path: "trainings",
          name: "RegistrationTrainingList",
          component: TrainingListView,
          meta: {
            title: i18n.global.t("page.training_list"),
            breadcrumb: true,
          },
        },
        {
          path: "alerts",
          name: "RegistrationAlertList",
          component: RegistrationAlertListView,
          meta: {
            title: i18n.global.tc("global.list.title", 1, {
              name: i18n.global.tc("registration.alert.title", 2).toLowerCase(),
            }),
            breadcrumb: true,
          },
        },
        {
          path: "group",
          name: "RegistrationGroup",
          component: GlobalLayoutView,
          meta: {
            title: i18n.global.tc("global.list.title", 1, {
              name: i18n.global.tc("studea_manager.group.title", 2).toLowerCase(),
            }),
            breadcrumb: true,
          },
          children: [
            {
              path: "list",
              name: "RegistrationGroupList",
              component: TrainingGroupListView,
              meta: {
                title: i18n.global.tc("global.list.title", 1, {
                  name: i18n.global.tc("studea_manager.group.title", 2).toLowerCase(),
                }),
                breadcrumb: false,
              },
            },
            {
              path: "add/:trainingCourseId",
              name: "RegistrationGroupAdd",
              component: TrainingGroupAddEditView,
              meta: {
                title: i18n.global.tc("global.add.title", 1, {
                  name: i18n.global.tc("studea_manager.group.title", 1).toLowerCase(),
                }),
                breadcrumb: true,
                displayTrainingName: true,
              },
            },
            {
              path: "edit/:id",
              name: "RegistrationGroupEdit",
              component: TrainingGroupAddEditView,
              meta: {
                title: i18n.global.tc("global.edit.title", 1, {
                  name: i18n.global.tc("studea_manager.group.title", 1).toLowerCase(),
                }),
                breadcrumb: true,
                displayTrainingName: true,
              },
            },
          ],
        },
        {
          path: "apprentice",
          name: "RegistrationApprentice",
          redirect: { name: "RegistrationApprenticeList" },
          component: GlobalLayoutView,
          meta: {
            title: i18n.global.tc("global.list.title", 1, {
              name: i18n.global.tc("studea_manager.apprentice.title", 2).toLowerCase(),
            }),
            breadcrumb: true,
          },
          children: [
            {
              path: "list",
              name: "RegistrationApprenticeList",
              component: ApprenticeListView,
              meta: {
                title: i18n.global.tc("global.list.title", 1, {
                  name: i18n.global.tc("studea_manager.apprentice.title", 2).toLowerCase(),
                }),
                breadcrumb: false,
              },
            },
            {
              path: "edit/:id",
              name: "RegistrationApprenticeEdit",
              component: ApprenticeAddEditView,
              meta: {
                title: i18n.global.tc("global.edit.title", 2, {
                  name: i18n.global.tc("studea_manager.apprentice.title", 1).toLowerCase(),
                }),
                breadcrumb: true,
              },
            },
          ],
        },
        {
          path: "insee-company",
          name: "RegistrationCompany",
          redirect: { name: "RegistrationCompanyList" },
          component: GlobalLayoutView,
          meta: {
            title: i18n.global.tc("global.list.title", 2, {
              name: i18n.global.tc("studea_manager.company.title", 2).toLowerCase(),
            }),
            breadcrumb: true,
          },
          children: [
            {
              path: "list",
              name: "RegistrationCompanyList",
              component: InseeCompanyListView,
              meta: {
                title: i18n.global.tc("global.list.title", 1, {
                  name: i18n.global.tc("studea_manager.company.title", 2).toLowerCase(),
                }),
                breadcrumb: false,
              },
            },
            {
              path: "view/:id",
              name: "RegistrationCompanyView",
              component: InseeCompanyViewView,
              meta: {
                title: i18n.global.tc("global.view.title", 2, {
                  name: i18n.global.tc("studea_manager.company.title", 1).toLowerCase(),
                }),
                breadcrumb: true,
              },
            },
          ],
        },
      ],
    },
  ],
};
